import  gql  from 'graphql-tag'

export const amountTermsFa = gql`query amountTermsFa{ 
    amountTermsFa{
            edges{
                node{
                    id,
                    data
                }
            }
        }
    }`;
